import { render, staticRenderFns } from "./AddressBlock.vue?vue&type=template&id=1d9b9176&"
import script from "./AddressBlock.vue?vue&type=script&lang=ts&"
export * from "./AddressBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports